import MessageScreen from './message-screen-view'

export default MessageScreen
